<template>
  <span>
    <span v-if="status == 'Aguardando Aprovação'" :class="`badge badge${isOutline ? '-outline' : ''}-warning`">{{
      $i18n.t(status)
    }}</span>
    <span v-else-if="status == 'Aprovado'" :class="`badge badge${isOutline ? '-outline' : ''}-primary`">{{
      $i18n.t(status)
    }}</span>
    <span v-else-if="status == 'Cancelado'" :class="`badge badge${isOutline ? '-outline' : ''}-danger`">{{
      $i18n.t(status)
    }}</span>
    <span v-else-if="status == 'Pago'" :class="`badge badge${isOutline ? '-outline' : ''}-success`">{{
      $i18n.t(status)
    }}</span>
    <span v-else-if="status == 'Sob Análise'" :class="`badge badge${isOutline ? '-outline' : ''}-info`">{{
      $i18n.t(status)
    }}</span>
    <span v-else-if="status == 'Pré-Aprovado'" :class="`badge badge${isOutline ? '-outline' : ''}-info`">{{
      $i18n.t(status)
    }}</span>
  </span>
</template>

<script>
export default {
  props: ['status', 'isOutline']
};
</script>

<style lang="scss" scoped></style>
